export class Isla {
    constructor(
        public idHospital: number,
        public idIsla: string,
        public idLider: number,
        public sync_id?: number
    ){}
}